module.exports = function getResource(label, vars = []) {
    let resources = {
        addedErrorMessage: 'This ColorIQ has already been added',
        defaultErrorMessage: 'Invalid Color IQ',
        defaultSkintone: 'Default Skintone',
        addNewColorIQ: 'Add new Color IQ',
        enterSkintoneNumber: 'Enter skintone number',
        addButton: 'Add',
        capturedOn: 'Captured on'
    };

    return resources[label];
};
